import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";
import { formatAppDate } from "../../helpers/date-formatter";
import DataTable from "../table/DataTable";
import { MediaCell } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";

function SliderTable({ sliders, onDelete }) {
  const columns = [
    {
      key: "slider",
      label: "Slider",
      render: (slider) => (
        <MediaCell
          src={slider.imageUrl}
          alt={slider.title}
          title={slider.title}
          subtitle={slider.description}
          size="lg"
        />
      ),
    },
    {
      key: "status",
      label: "Status",
      width: "150px",
      render: (slider) => <StatusBadge active={slider.active} />,
    },
    {
      key: "position",
      label: "Order",
      width: "120px",
      render: (slider) => slider.position,
    },
    {
      key: "createdOn",
      label: "Created On",
      width: "150px",
      render: (slider) => formatAppDate(slider.createdOn),
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "120px",
      render: (slider) => (
        <ActionGroup>
          <ActionButton as={Link} to={`/slider/${slider.id}/edit`} color="blue" title="Edit">
            <PencilSquareIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton color="red" onClick={() => onDelete(slider)} title="Delete">
            <TrashIcon className="h-5 w-5" />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={sliders}
      rowKey="id"
      minWidth="820px"
      emptyMessage="No sliders found."
    />
  );
}

export default SliderTable;
